// Fachada do gateway Auth — métodos da instância (ver core.ts).
import { authGateway, passwordResetService } from './core';

export const signUp                = authGateway.signUp;
export const signInWithPassword    = authGateway.signInWithPassword;
export const setSession            = authGateway.setSession;
export const getSession            = authGateway.getSession;
export const updateUser            = authGateway.updateUser;
export const getCurrentUser        = authGateway.getCurrentUser;
export const onAuthStateChange     = authGateway.onAuthStateChange;
export const signOut               = authGateway.signOut;

// ── Reset de senha por link de uso único ──────────────────────────
export const requestPasswordReset     = passwordResetService.requestReset;
export const adminCreatePasswordReset = passwordResetService.adminCreateReset;
export const lookupPasswordReset      = passwordResetService.lookupReset;
export const consumePasswordReset     = passwordResetService.consumeReset;

export { MIN_PASSWORD_LENGTH } from '@modules/auth';

export type { AuthUser } from '@modules/auth';

export type { AuthResult, SignUpResult, PasswordResetLookup, AdminResetLink } from '@modules/auth';
